import { render } from "./PolicyView.vue?vue&type=template&id=4ccc3021&lang=pug"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import "./PolicyView.vue?vue&type=style&index=0&id=4ccc3021&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__